module.exports = __webpack_public_path__ + "static/media/swish-vertical-main.39cae6fb.png";